import styled from '@emotion/styled';
import React from 'react';
import { ITheme } from '../../../../../ui';
import { useTranslation } from '../../../../shared/i18n/translate/useTranslation';
import { IBookingPaymentDetails } from '../../../domain/booking/models/IBooking';
import { IPersonalDetails } from '../../../domain/booking/models/IPersonalDetails';
import { IVehicleDetails } from '../../../domain/booking/models/IVehicleDetails';
import {
	StyledBookingDetailsCell as Cell,
	StyledBookingDetailsRow as Row,
	StyledBookingDetailsTable as Table,
	StyledBookingDetailsTableBody as TableBody,
} from '../../booking/BookingDetailsTable';
import { BookingPaymentMethod } from '../../booking/BookingPaymentMethod';

interface IPersonalBookingDetailsProps {
	personalDetails: IPersonalDetails;
	paymentDetails: IBookingPaymentDetails;
	vehicleDetails: IVehicleDetails;
}

export const BookingPersonalDetailsTable = ({
	personalDetails,
	paymentDetails,
	vehicleDetails,
}: IPersonalBookingDetailsProps) => {
	const { t } = useTranslation();

	return (
		<StyledTable>
			<TableBody>
				<Row>
					<Cell light>
						{`${t('parking_booking_details_first_name_label')}:`}
					</Cell>
					<Cell>{personalDetails.firstName}</Cell>
				</Row>
				<Row>
					<Cell light>
						{`${t('parking_booking_details_last_name_label')}:`}
					</Cell>
					<Cell>{personalDetails.lastName}</Cell>
				</Row>
				<Row>
					<Cell light>
						{`${t('parking_booking_details_email_address_label')}:`}
					</Cell>
					<Cell>{personalDetails.email}</Cell>
				</Row>
				<Row>
					<Cell light>
						{`${t('parking_booking_details_phone_number_label')}:`}
					</Cell>
					<Cell>{personalDetails.phoneNumber}</Cell>
				</Row>
				<Row>
					<Cell light>{`${t('parking_booking_details_address_label')}:`}</Cell>
					<Cell>{personalDetails.address}</Cell>
				</Row>
				<Row>
					<Cell light>{`${t('parking_booking_details_city_label')}:`}</Cell>
					<Cell>{personalDetails.city}</Cell>
				</Row>
				<Row>
					<Cell light>{`${t('parking_booking_details_state_label')}:`}</Cell>
					<Cell>{personalDetails.state}</Cell>
				</Row>
				<Row>
					<Cell light>{`${t('parking_booking_details_zip_code_label')}:`}</Cell>
					<Cell>{personalDetails.zipCode}</Cell>
				</Row>
				<Row>
					<Cell light>{`${t('parking_booking_details_payment_label')}:`}</Cell>
					<Cell>
						<BookingPaymentMethod paymentDetails={paymentDetails} />
					</Cell>
				</Row>
				<Row>
					<Cell light>{`${t('parking_booking_details_license_plate')}:`}</Cell>
					<Cell>{vehicleDetails.licensePlateNumber}</Cell>
				</Row>
			</TableBody>
		</StyledTable>
	);
};

const StyledTable = styled(Table)<{}, ITheme>`
	font-size: 16px;

	${Cell} {
		vertical-align: bottom;
		padding-bottom: 4px;

		&:last-of-type {
			text-align: right;
		}
	}
`;
